import { render, staticRenderFns } from "./AppointmentLog.vue?vue&type=template&id=6f95af21&scoped=true"
import script from "./AppointmentLog.vue?vue&type=script&lang=js"
export * from "./AppointmentLog.vue?vue&type=script&lang=js"
import style0 from "./AppointmentLog.vue?vue&type=style&index=0&id=6f95af21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95af21",
  null
  
)

export default component.exports